var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35 1l6 4.5-6 4.5M1 5l40 .5","stroke":"#000","fill":"none","fillRule":"evenodd"}));
}

ArrowRight.defaultProps = {"width":"42","height":"11"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
